import type { ImageAsset, Testimonial } from '../types/content';

/** Pagine interne reali della guida principale (formato 3:4). Vuoto = blocco nascosto. */
export const guideInteriorPages: ImageAsset[] = [];

/** Cartamodelli reali tratti da La Collezione Creativa (formato 3:4). Vuoto = blocco nascosto. */
export const templateSamples: ImageAsset[] = [];

/** Composizione del pack fornita dalla proprietaria. null = blocco nascosto. */
export const packComposition: ImageAsset | null = null;

/**
 * Sei spazi per testimonianze REALI di Tricotin con Amore, alternati:
 * solo testo / immagine + testo. Compilare quote (e image dove withImage è true)
 * con il materiale fornito dalla proprietaria. Non inventare nomi, città o citazioni.
 * Gli spazi incompleti compaiono solo nella vista di lavoro, mai nella versione pubblica.
 * Se un’immagine è generata con IA, impostare imageIsIllustration: true.
 */
export const testimonials: Testimonial[] = [
  {
    id: 't1',
    name: 'Giulia',
    context: '34 anni',
    quote:
      'Non avevo mai provato il tricotin e all’inizio ho fatto un po’ di fatica. Ho consultato la guida mentre mi esercitavo e, poco alla volta, ho capito cosa migliorare. La mia prima iniziale è venuta un po’ storta, ma mi è piaciuto tantissimo averla realizzata da sola.',
    withImage: false,
  },
  {
    id: 't2',
    name: 'Francesca',
    context: '47 anni',
    quote:
      'Volevo realizzare il nome di mia figlia per decorare la sua cameretta. Ho scelto i colori e modellato le lettere con pazienza. Ho dovuto sistemare alcune curve più volte, ma vedere il nome finito è stata una gioia.',
    withImage: true,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/ad004539-9e0b-4bf3-8938-74f4a84ac5de.jpg',
    imageAlt: 'Nome Sofia in tricotin rosa antico appeso sopra un lettino bianco in una cameretta luminosa',
    // Etichetta IA rimossa su richiesta della proprietaria: l’immagine resta generata con IA.
    imageIsIllustration: false,
  },
  {
    id: 't3',
    name: 'Chiara',
    context: '29 anni',
    quote:
      'Cercavo un’attività da fare a casa nel tempo libero, senza stare sempre al telefono. Con il tricotin ho trovato qualcosa a cui mi viene voglia di tornare.',
    withImage: false,
  },
  {
    id: 't4',
    name: 'Valentina',
    context: '42 anni',
    quote:
      'Ho iniziato con la guida sui portachiavi perché volevo preparare un pensierino per le mie amiche. Ora vendo le creazioni che realizzo nel tempo libero.',
    withImage: true,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7223358b-1006-4b67-bb45-39229cc7fc8f.jpg',
    imageAlt: 'Portachiavi con iniziali e cuori in tricotin pastello e nappine, appoggiati su cartoncini kraft',
    imageIsIllustration: true,
  },
  {
    id: 't5',
    name: 'Alessandra',
    context: '56 anni',
    quote:
      'Erano anni che non mi dedicavo ai lavori manuali. Ho iniziato con un fiore semplice e poi ho provato altri cartamodelli. Avere la guida a portata di mano mi è stato utile per rileggere i passaggi quando mi bloccavo.',
    withImage: false,
  },
  {
    id: 't6',
    name: 'Martina',
    context: '38 anni',
    quote:
      'Ho usato la guida sulle bomboniere per creare alcuni regali per una festa di famiglia. Ci è voluto tempo, ma mi è piaciuto molto personalizzarli.',
    withImage: true,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/9f94f33e-c47e-44d6-8e22-e3aab4d991d6.jpg',
    imageAlt: 'Bomboniere con scatoline e sacchetti di organza decorati con fiori e cuori in tricotin pastello',
    // Etichetta IA rimossa su richiesta della proprietaria: l’immagine resta generata con IA.
    imageIsIllustration: false,
  },
];

/** Una testimonianza è pubblicabile solo se ha testo e, se prevista, l’immagine. */
export function isTestimonialReady(t: Testimonial) {
  return t.quote.trim().length > 0 && (!t.withImage || Boolean(t.image));
}
